
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Editor } from '@tiptap/core';
import MenuButton from '@/components/tiptap/Menu/MenuButton.vue';

@Component({
  components: {
    MenuButton,
  },
})
export default class MenuHorizontalRuleButton extends Vue {
  @Prop({ required: true }) editor: Editor;
  @Prop({ default: () => {} }) command: () => void;

  runCommand() {
    this.editor.chain().focus().setHorizontalRule().run();
    this.command();
  }
}
